import React from 'react';
import { FallbackProps } from 'react-error-boundary';

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

const ErrorFallback = ({ resetErrorBoundary }: FallbackProps) => {
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
    resetErrorBoundary();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{'We are experiencing technical difficulties'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Something has gone wrong. Please click continue to reload the website and try again.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ErrorFallback;
